import { AccordionItem, Text, List } from 'braid-design-system';
export const ConfidentialInformation = () => (
  <AccordionItem id="confidential-information" label="Confidential Information">
    <List type="number" start={20}>
      <Text>
        Communications between you and the SEEK Group should be regarded as
        confidential unless we expressly provide otherwise. You may only use
        such confidential information for the purposes of performing your
        obligations or exercising your rights under these Terms. You must not
        disclose confidential information to any third party without our prior
        written consent. If you are unsure about whether any information that is
        communicated to you is confidential in nature, you should treat that
        information as confidential and confirm with us prior to disclosure of
        that information.
      </Text>
    </List>
  </AccordionItem>
);
